import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useWallet } from '../../contexts/WalletContext';
import Header from './Header';
import Sidebar from './Sidebar';
import MobileNav from './MobileNav';
import MobileMenuToggle from '../common/MobileMenuToggle';
import '../../styles/app-layout.css';

const AppLayout = ({ children, currentView, setCurrentView }) => {
  const { user } = useAuth();
  const { wallets } = useWallet();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSessions, setActiveSessions] = useState([]);
  const [alerts, setAlerts] = useState([]);

  // Map currentView to sidebar activeTab
  const getActiveTab = () => {
    switch (currentView) {
      case 'solana-tokens':
        return 'solana-tokens';
      case 'dashboard':
        return 'dashboard';
      case 'trading':
      case 'compact-trading':
        return 'manual';
      case 'wallets':
        return 'automated';
      case 'assets':
        return 'sessions';
      case 'history':
        return 'history';
      case 'tokens':
      case 'discover':
        return 'analytics';
      case 'monitor':
        return 'alerts';
      case 'alerts':
        return 'price-alerts';
      case 'opportunities':
        return 'opportunities';
      case 'investment':
        return 'investment';
      case 'admin':
        return 'admin';
      case 'settings':
        return 'settings';
      default:
        return 'solana-tokens';
    }
  };

  // Handle sidebar navigation
  const handleSidebarNavigation = (tabId) => {
    switch (tabId) {
      case 'solana-tokens':
        setCurrentView('solana-tokens');
        break;
      case 'dashboard':
        setCurrentView('dashboard');
        break;
      case 'manual':
        setCurrentView('trading');
        break;
      case 'automated':
        setCurrentView('wallets');
        break;
      case 'sessions':
        setCurrentView('assets');
        break;
      case 'alerts':
        setCurrentView('monitor');
        break;
      case 'price-alerts':
        setCurrentView('alerts');
        break;
      case 'opportunities':
        setCurrentView('opportunities');
        break;
      case 'investment':
        setCurrentView('investment');
        break;
      case 'admin':
        setCurrentView('admin');
        break;
      case 'history':
        setCurrentView('history');
        break;
      case 'analytics':
        setCurrentView('tokens');
        break;
      case 'settings':
        setCurrentView('settings');
        break;
      default:
        setCurrentView('solana-tokens');
    }
  };

  // Fetch data for sidebar badges (simplified for now)
  useEffect(() => {
    // In a real app, you'd fetch this data from your API
    setActiveSessions([]); // Mock data
    setAlerts([]); // Mock data
  }, []);

  return (
    <div className="app-layout">
      <Header
        currentView={currentView}
        setCurrentView={setCurrentView}
        onMobileMenuToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      />

      <div className="app-body">
        <MobileMenuToggle
          isOpen={isMobileMenuOpen}
          onToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        />

        <Sidebar
          activeTab={getActiveTab()}
          setActiveTab={handleSidebarNavigation}
          activeSessions={activeSessions}
          alerts={alerts}
          isMobileOpen={isMobileMenuOpen}
          onMobileClose={() => setIsMobileMenuOpen(false)}
        />

        <div className="app-main-content">
          {children}
        </div>
      </div>

      <MobileNav
        currentView={currentView}
        setCurrentView={setCurrentView}
      />
    </div>
  );
};

export default AppLayout;